export default "__VITE_ASSET__DyzZdQP7__"